import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import NavSprite from "../../../assets/sprites/navigation/topic_background.jpg";
import { SCREENS } from "../components/responsive";
import { TopBanner } from "./topbar";
import { Link, useLocation } from "react-router-dom";

const NavbarContainer = styled.div``;

const TopNavWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: url(${NavSprite});
  background-repeat: repeat-x;
  background-size: 128px 100%;
  width: 100%;
`;

const TopNavigation = styled.div`
  @media (min-width: 950px) {
    justify-content: space-around;
  }
  display: flex;
  flex-direction: row;

  overflow-x: auto;
  white-space: nowrap;
  flex-grow: 1;
  &::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #ffffff;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
`;

const TopNavElement = styled.div`
  font-family: "Martel";

  font-size: 1.4rem;

  padding: 3px 0;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
  padding: 4px 30px;
  a {
    color: white;
    text-decoration: none;
  }
`;

const NavActive = styled.div`
  width: 180px;
  font-family: "Martel";
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  color: #e6e65d;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
  text-transform: capitalize;
`;

export default function TopNav() {
  const isMobile = useMediaQuery({
    maxWidth: SCREENS.md,
  });
  const location = useLocation();
  return (
    <NavbarContainer>
      <TopBanner />
      <TopNavWrapper>
        {!isMobile ? (
          <NavActive>
            {location.pathname === "/"
              ? "Home"
              : location.pathname.substring(1)}
          </NavActive>
        ) : null}
        <TopNavigation>
          <TopNavElement>
            <Link to="/">Home</Link>
          </TopNavElement>
          <TopNavElement>
            <Link to="/game">The Game</Link>
          </TopNavElement>
          <TopNavElement>
            <Link to="/">Buy Tokens</Link>
          </TopNavElement>
          <TopNavElement>
            <Link to="/">Market Place</Link>
          </TopNavElement>
          <TopNavElement>
            <Link to="/">Support</Link>
          </TopNavElement>
        </TopNavigation>
      </TopNavWrapper>
    </NavbarContainer>
  );
}
